/* eslint-disable react/no-multi-comp */

import React from "react";
import createReactClass from "create-react-class";
import Actions from "okpay/actions/Actions";
import C from "okpay/util/Constants";
import Str from "shared/components/Str";
import _str from "shared/util/_str";

import "./nav.scss";

const NavButton = createReactClass({
	displayName: "NavButton",
	mixins: [React.addons.PureRenderMixin],

	_onClick(e) {
		if (this.props.isSubmitting) {
			return;
		}

		Actions.changeBillingType(this.props.id);
	},

	render() {
		if (this.props.hidden) {
			return null;
		}

		return (
			<button
				className={`okpay-nav-item okpay-nav-item-${this.props.id}`}
				key={this.props.id}
				onClick={this._onClick}
			>
				{this.props.children}
			</button>
		);
	},
});

const Nav = createReactClass({
	displayName: "Nav",
	mixins: [React.addons.PureRenderMixin],

	render() {
		const { skipPaypal } = this.props;
		let navItems = [
			{
				id: C.billingTypes.card,
				name: _str("Credit/Debit"),
			},
			{
				id: C.billingTypes.paypal,
				name: _str("PayPal"),
				hidden: skipPaypal,
			},
		];

		navItems = navItems.map((item) => {
			return (
				<NavButton
					{...item}
					key={item.id}
					product={this.props.product}
					isSubmitting={this.props.isSubmitting}
				>
					{item.name}
				</NavButton>
			);
		});

		return <div className="okpay-nav">{navItems}</div>;
	},
});

export default Nav;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/Nav.jsx